import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "src/components/ui/button";
import { usePropertyListings } from "src/features/properties/hooks/usePropertyListings";
import { useListingPublishControls } from "src/features/properties/hooks/useListingPublishControls";
import { PropertyListingsTable } from "src/features/properties/components/PropertyListingsTable";
import { DeletePropertyModal } from "src/features/properties/components/DeletePropertyModal";
import { PropertyListingDrawer } from "src/features/properties/components/PropertyListingDrawer";

export default function SellerPropertiesPage() {
  const [page, setPage] = useState(1);
  const { data, loading, fetch } = usePropertyListings();
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  const reload = () => fetch({ listing_type: "sale", page, per_page: 20 });

  useEffect(() => {
    fetch({ listing_type: "sale", page, per_page: 20 });
  }, [fetch, page]);

  const { onTogglePublish, onCopyLink, publishPendingId } =
    useListingPublishControls({ onChanged: reload });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-900">Sale Listings</h2>
        <Button onClick={() => { setEditRecord(null); setIsDrawerOpen(true); }}>
          <Plus className="h-4 w-4 mr-1.5" />
          Add Listing
        </Button>
      </div>

      <PropertyListingsTable
        listings={data?.listings || []}
        meta={data?.meta}
        loading={loading}
        page={page}
        onPageChange={setPage}
        onShow={(record) => { setEditRecord(record); setIsDrawerOpen(true); }}
        onEdit={(record) => { setEditRecord(record); setIsDrawerOpen(true); }}
        onDelete={setDeleteRecord}
        onNewListing={() => { setEditRecord(null); setIsDrawerOpen(true); }}
        onTogglePublish={onTogglePublish}
        onCopyLink={onCopyLink}
        publishPendingId={publishPendingId}
        isRental={false}
      />

      <DeletePropertyModal
        open={!!deleteRecord}
        onClose={() => setDeleteRecord(null)}
        record={deleteRecord}
        type="listing"
        onSuccess={() => fetch({ listing_type: "sale", page, per_page: 20 })}
      />

      <PropertyListingDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        listing={editRecord}
        onSuccess={() => fetch({ listing_type: "sale", page, per_page: 20 })}
        isRental={false}
      />
    </div>
  );
}
